// ============================================================
//  MĀKARA VILLAGE BOARDING CATTERY — EDITABLE BUSINESS DATA
//  Cody: update the values in this ONE file and the whole
//  website updates. No other code changes needed.
// ============================================================

export const site = {
    name: "Mākara Village Boarding Cattery",
    shortName: "Mākara Cattery",
    tagline: "More than 20 years of family care in Mākara.",
    // Hero introduction — paragraphs separated by a blank line (\n\n).
    // The first two show in the hero; storyWelcome leads the Our Story area.
    heroSub:
        "Welcome to our family-run cattery, nestled in the peaceful countryside of Mākara, Wellington.\n\nHere, every cat is treated like one of our own. Each fluffy guest enjoys their own private accommodation, with plenty of love, care, attention and cuddles throughout the day.",
    storyWelcome: [
        "Welcome to Mākara Village Boarding Cattery!",
        "We’re a family-run business with over 20 years of experience looking after cats, and we like to think we’ve created something a little bit special out here in the beautiful Mākara countryside.",
        "Our philosophy has always been pretty simple. We want our cats to have just as much fun on holiday as their owners do!",
        "During the day, our cats have the opportunity to explore, climb, play, relax and enjoy their surroundings, before being safely tucked away for the night.",
        "We often describe the cattery as a cross between a school holiday programme and Disneyland for cats! There’s plenty to keep them entertained, lots to discover, and always somewhere comfortable to curl up and have a snooze.",
        "We know how important your cats are to you. That’s why we’ve worked hard over the years to create a place where they can feel comfortable, safe and well cared for while you’re away.",
        "At the end of the day, we’re cat lovers ourselves, and we want every cat who comes to stay with us to have a wonderful little holiday of their own.",
    ],
    locationLine: "Mākara · Wellington · New Zealand",
};

// ---- PRICING ------------------------------------------------
// Change these numbers and every price on the site updates.
export const pricing = {
    standardRate: 20, // NZ$ per cat, per calendar day
    peakRate: 25, // NZ$ per cat, per calendar day during peak months
    peakMonths: [11, 0], // December (11) & January (0) — JS month numbers
    peakLabel: "December & January",
    medicationRate: 2, // NZ$ per administration, per cat
    currency: "NZ$",
};

// ---- OPENING / DROP-OFF HOURS -------------------------------
export const hours = {
    morning: "8:30am – 11:00am",
    afternoon: "3:00pm – 6:00pm",
    days: "Seven days a week",
    closedDays: ["Christmas Day", "Boxing Day", "New Year's Day"],
    note: "These are customer drop-off and collection hours. Your cats are checked, fed and cared for seven days a week, including outside these times.",
};

// ---- TRANSPORT ------------------------------------------------------
// Limited collection/drop-off/vet transport service, prior arrangement only.
export const transport = {
    intro: "We offer a limited cat collection, drop-off and veterinary transport service by prior arrangement.",
    rates: [
        { area: "Karori", eachWay: 30, ret: 60 },
        { area: "Wellington City", eachWay: 50, ret: 100 },
    ],
    vetNote:
        "Veterinary transport — the same area-based rates apply. Veterinary consultation and treatment fees are additional.",
    conditions: [
        "Collection and return journeys are charged separately.",
        "All transport must be arranged directly with the cattery in advance, and is subject to staff availability.",
        "Transport may be available during or outside normal customer opening hours.",
        "This service is not guaranteed or available daily — please contact us to discuss availability before making arrangements.",
    ],
};

// ---- NOTICES / UPCOMING CLOSURES ----------------------------
// Add a notice like: { date: "15 August 2026", text: "Closed for maintenance" }
// Leave the list empty and the site shows "open as usual".
export const notices = [];

// ---- CONTACT ------------------------------------------------
// ⚠️ Add the real landline, mobile and email here when ready.
// While pending: true, those contact buttons simply don't
// appear on the public website (no placeholder text is shown).
export const contact = {
    landline: { display: "04 476 9424", href: "+6444769424", pending: false },
    mobile: { display: "027 476 9424", href: "+64274769424", pending: false },
    email: { display: "makaracattery@gmail.com", href: "makaracattery@gmail.com", pending: false },
    // Full street address — confirmed by the business for publication.
    address: {
        line1: "384 Mākara Road",
        line2: "Mākara, Wellington",
        country: "New Zealand",
        note: "We’re located at the rear of the property. Please follow the signs to the cattery.",
    },
    mapQuery: "384 Mākara Road, Mākara, Wellington, New Zealand",
    // Exact map URLs supplied by the business.
    directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=384%20Makara%20Road%2C%20Makara%2C%20Wellington%2C%20New%20Zealand&travelmode=driving",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=384%20Makara%20Road%2C%20Makara%2C%20Wellington%2C%20New%20Zealand",
};

// ---- SOCIAL MEDIA -------------------------------------------
// ⚠️ Paste the exact verified URLs here when confirmed.
// Until then the buttons tell visitors what to search for.
export const socials = [
    { id: "facebook", label: "Facebook", account: "Mākara Cattery NZ", url: "https://www.facebook.com/share/1Ecg3wEFBG/?mibextid=wwXIfr" },
    { id: "instagram", label: "Instagram", account: "Mākara Cattery", url: "https://www.instagram.com/makara_cattery" },
    { id: "tiktok", label: "TikTok", account: "Mākara Cattery", url: "https://www.tiktok.com/@makara.cattery" },
];

// ---- INSTAGRAM LIVE GALLERY ---------------------------------
// Set connected: true once the official Instagram account is
// linked through Meta. Until then the gallery shows a tasteful
// "photos coming soon" state.
export const instagram = {
    connected: false,
    accountName: "@makara_cattery",
};

// ---- REVIEWS -------------------------------------------------
// 5.0 rating from 24 Google reviews (as supplied).
// Paste Cody's confirmed genuine reviews into `testimonials`:
// { name: "Sarah M.", text: "..." }
// NEVER invent reviews — genuine quotes only.
export const reviews = {
    googleUrl: "", // paste the Google reviews link when confirmed
    // Genuine phrases customers have used (supplied by the business):
    customerPhrases: ["Cat Disneyland", "Club Med for cats", "A home away from home"],
    // Genuine Google reviews supplied by the business (wording preserved exactly):
    testimonials: [
        { name: "Wendy Mawson", text: "Cody is the best, he cares for all his ‘fur baby customers’ as if they were his own." },
        { name: "AnneMarie Curtis", text: "Cody is great and the set up he has is amazing, with lots of room for your cat to explore and relax. Just a really chill and caring place to send your cat." },
        { name: "Sarah Moran", text: "This review is long overdue. We’ve been going to Makara Cattery for a while now and have always been impressed. Cody takes amazing care of our cat and sets us at ease too." },
    ],
};

// ---- LEGAL ----------------------------------------------------
// Placeholder legal text — replace with the business's real
// policies before launch. Do not publish invented legal terms.
export const legal = {
    // Full Terms & Conditions — rendered on the dedicated page
    // at #/terms-and-conditions (linked from the footer and booking form).
    termsIntro: [
        "At Mākara Village Boarding Cattery, we are committed to providing a safe, comfortable and loving environment for every cat in our care.",
        "As a family-run cattery, we treat our guests like members of our own family.",
        "Please read the following Terms & Conditions before confirming your booking. These explain our daily operations, fees, health requirements and responsibilities.",
    ],
    // Blocks per section: "string" = paragraph, { sub } = sub-heading,
    // { list } = bullet list. Wording as supplied by the business.
    termsSections: [
        {
            title: "Bookings and Accommodation",
            blocks: [
                "All bookings are subject to availability and must be confirmed in advance.",
                "Each cat is provided with its own private accommodation, unless an alternative arrangement has been agreed.",
                "Our team provides daily cleaning, fresh water, feeding, monitoring, attention and opportunities for suitable enrichment and activity.",
                "We care for cats seven days a week, including outside customer visiting hours.",
            ],
        },
        {
            title: "Boarding Prices",
            blocks: [
                "Our published boarding rates are:",
                {
                    list: [
                        "Standard boarding: NZ$20 per cat, per calendar day, effective from 1 February 2026.",
                        "Christmas holiday boarding: NZ$25 per cat, per calendar day, for December 2026 and January 2027.",
                    ],
                },
                { sub: "How calendar-day charging works" },
                "We charge per calendar day, not per night or per 24-hour period.",
                "Every dated day that your cat is in our care is chargeable, including the day of arrival and the day of collection.",
                "For example: a cat arriving on Friday and leaving on Sunday is charged for three calendar days — Friday, Saturday and Sunday.",
                { sub: "Christmas minimum booking charge" },
                "During the Christmas holiday period, a minimum charge equivalent to ten days of boarding applies per cat.",
                "For the December 2026–January 2027 holiday period, this equals NZ$250 per cat at the Christmas rate.",
                "Your cat does not need to stay for the full ten days, but the minimum charge still applies to bookings covered by this policy.",
                "The applicable Christmas booking period and minimum charge should be clearly communicated before the booking is confirmed.",
            ],
        },
        {
            title: "Payments and Deposits",
            blocks: [
                "Full payment is due on the day of collection unless payment has been arranged earlier.",
                "Accepted payment methods include:",
                { list: ["Bank transfer", "Cash", "Approved electronic payment methods"] },
                "A deposit may be required for Christmas, other peak periods or long-term bookings.",
                "Any deposit amount, refund conditions and cancellation requirements will be communicated before confirmation.",
            ],
        },
        {
            title: "Opening Hours and Out-of-Hours Services",
            blocks: [
                "We operate seven days a week.",
                { list: ["Morning: 8:30 am – 11:00 am", "Afternoon: 3:00 pm – 6:00 pm"] },
                "Drop-offs and collections must take place during these hours unless an alternative time has been arranged in advance.",
                { sub: "Out-of-hours fees" },
                {
                    list: [
                        "Standard out-of-hours arrangement: NZ$20.",
                        "Out-of-hours arrangement during December and January: NZ$50.",
                    ],
                },
                "Out-of-hours visits are available by prior agreement only.",
                { sub: "Public holiday closures" },
                "The cattery is closed to customer drop-offs and collections on:",
                {
                    list: [
                        "Christmas Day — 25 December",
                        "Boxing Day — 26 December",
                        "New Year’s Day — 1 January",
                    ],
                },
                "Cats already boarding continue to receive normal daily care on these days.",
                "Any additional closure dates will be communicated through the booking system or directly to customers.",
            ],
        },
        {
            title: "Veterinary Care and Emergencies",
            blocks: [
                "Your cat’s health, safety and wellbeing are our priority.",
                "If a cat becomes unwell or requires veterinary attention during its stay, we will take reasonable steps to obtain appropriate veterinary care.",
                "We have maintained a trusted relationship with Karori Vet for more than 20 years.",
                "Unless otherwise arranged in advance, Karori Vet is our preferred veterinary provider.",
                "We will make reasonable efforts to contact the owner before non-urgent veterinary treatment.",
                "In an emergency, where immediate attention is required and the owner cannot be reached, we may arrange veterinary care in the cat’s best interests.",
                { sub: "Veterinary transport charges" },
                {
                    list: [
                        "Transport to Karori Vet: NZ$30 each way.",
                        "Transport to other veterinary clinics: NZ$50 each way.",
                    ],
                },
                "Veterinary treatment and associated costs are the owner’s responsibility, except where responsibility rests with the cattery under applicable law.",
            ],
        },
        {
            title: "Illness, Medical Emergencies & Unexpected Death",
            blocks: [
                "At Mākara Village Boarding Cattery, the health, safety and wellbeing of every cat in our care is extremely important to us. We treat every guest with kindness, compassion and the same level of care we would want for our own pets.",
                "While we take all reasonable precautions to provide a safe, clean and caring environment, we acknowledge that cats, like all living animals, may experience sudden illness, unexpected medical emergencies or natural death, sometimes without any prior symptoms or warning.",
                { sub: "Medical Emergencies" },
                "Should a cat become seriously unwell or require urgent medical attention during its stay, we reserve the right to seek veterinary assistance where reasonably necessary.",
                "We will make reasonable efforts to contact the owner or their nominated emergency contact as soon as practicable.",
                "The owner authorises reasonable emergency veterinary treatment where necessary for the cat’s welfare. Veterinary fees and associated expenses will ordinarily be the responsibility of the owner, except where the cattery is legally responsible.",
                { sub: "Unexpected Death During Boarding" },
                "In the unfortunate event that a cat passes away while staying at Mākara Village Boarding Cattery, we will handle the situation with dignity, compassion and respect.",
                "We will notify the owner or nominated emergency contact as soon as reasonably practicable and, where appropriate, arrange veterinary assessment or confirmation of death.",
                "Where possible, the owner’s wishes regarding the care and collection of their deceased pet will be respected. We will not arrange cremation or other final disposition without the owner’s consent, except where otherwise required by law or unavoidable circumstances.",
                { sub: "Responsibility & Liability" },
                "Owners acknowledge that unforeseen illness, underlying medical conditions, age-related complications and natural death can occur despite reasonable care and supervision.",
                "Mākara Village Boarding Cattery is not responsible for illness, injury or death arising solely from natural causes, pre-existing or undisclosed medical conditions, or other circumstances beyond our reasonable control, provided we have exercised reasonable care and skill.",
                "Nothing in these terms excludes or limits any rights or remedies available under the Consumer Guarantees Act 1993 or any other applicable New Zealand law.",
                { sub: "Our Commitment" },
                "We understand that cats are much-loved members of the family. In the unfortunate event of a serious medical incident or loss, we will always endeavour to communicate openly, act compassionately and treat both the cat and its family with the utmost respect.",
            ],
        },
        {
            title: "Medication",
            blocks: [
                "We can administer suitable medications when instructions are provided and the treatment is within our safe handling capabilities.",
                { sub: "Medication charges" },
                { list: ["Morning medication session: NZ$5", "Evening medication session: NZ$5"] },
                "All medication must be clearly labelled with the cat’s name, dosage and administration instructions.",
                "Owners must disclose medication requirements before confirming a booking.",
                "We reserve the right to decline a booking where the medical care required is beyond our safe handling capabilities.",
                "Injectable medications are not administered.",
            ],
        },
        {
            title: "Feeding and Drinking Water",
            blocks: [
                "We provide Iams dry cat biscuits as our standard base diet.",
                "Fresh drinking water is available at all times.",
                "If your cat requires a special diet, veterinary-prescribed food or particular feeding arrangements, please provide sufficient food for the entire stay.",
                "Special food must be clearly labelled with your cat’s name and feeding instructions.",
                "Please advise us of allergies or dietary restrictions before arrival.",
            ],
        },
        {
            title: "Bedding and Personal Belongings",
            blocks: [
                "We provide:",
                {
                    list: [
                        "Bedding and blankets",
                        "Food and water bowls",
                        "Litter trays",
                        "Suitable accommodation and enrichment",
                    ],
                },
                "For hygiene and safety reasons, personal belongings are generally not permitted unless specifically approved in advance.",
                "This helps us maintain a clean and consistent environment for all cats in our care.",
            ],
        },
        {
            title: "Health and Vaccination Requirements",
            blocks: [
                "Before entering the cattery, cats must:",
                {
                    list: [
                        "Be treated for fleas",
                        "Have current F3 or F4 vaccinations, with supporting vaccination records",
                        "Be wormed",
                        "Be desexed if over six months old",
                        "Be in suitable general health for boarding",
                        "Be free from known contagious conditions",
                    ],
                },
                "Vaccination documentation is required on the first visit and updated annually thereafter.",
                "Owners must disclose any medical conditions, allergies, behavioural concerns or special care requirements when booking.",
                "We may refuse admission if a cat appears unwell, has fleas, presents a contagious risk or requires care we cannot safely provide.",
            ],
        },
        {
            title: "Owner Information",
            blocks: [
                "Before each stay, owners must provide accurate and current information, including:",
                {
                    list: [
                        "Full name",
                        "Contact telephone number",
                        "Email address",
                        "Regular veterinary clinic",
                        "Cat’s vaccination information",
                        "Relevant medical or behavioural information",
                    ],
                },
                "Owners must remain contactable during their cat’s stay or provide an appropriate alternative emergency contact.",
                "Unless otherwise agreed in advance, Karori Vet will be our preferred veterinary provider.",
                "Personal information will be used for booking administration, communication and appropriate animal care, and handled in accordance with applicable privacy requirements.",
            ],
        },
        {
            title: "Collection and Uncollected Cats",
            blocks: [
                "Cats must be collected on the agreed collection date unless an extension has been arranged.",
                "If a cat remains uncollected and we cannot contact the owner, we will make reasonable efforts to reach the owner using the supplied contact information.",
                "If no contact has been established after seven days, we may take further reasonable steps to establish the owner’s intentions and ensure the cat’s ongoing welfare.",
                "If a cat remains uncollected for 30 days without communication, we may seek advice from the appropriate animal welfare authorities about lawful next steps and suitable care arrangements.",
                "We will not automatically transfer ownership or rehome a cat solely because 30 days have passed.",
                "Additional boarding and reasonable care expenses may continue to apply where legally recoverable.",
            ],
        },
        {
            title: "Responsibility and Liability",
            blocks: [
                "We take reasonable precautions to provide a safe, clean and caring environment.",
                "However, animals may experience illness, injury or unexpected health complications, including those related to age, pre-existing conditions or stress.",
                "Owners are responsible for disclosing relevant health and behavioural information before boarding.",
                "Veterinary costs are generally the responsibility of the owner, except where the cattery is legally responsible.",
                "Nothing in these Terms & Conditions excludes or limits any rights or remedies that cannot lawfully be excluded under New Zealand law.",
            ],
        },
        {
            title: "Cancellations and Booking Changes",
            blocks: [
                "We understand that travel plans can change.",
                "Please notify us as early as possible if you need to cancel or amend your booking.",
                "Cancellations within 48 hours of the scheduled arrival may incur a cancellation fee, where the fee has been communicated and agreed to as part of the booking terms.",
                "Peak-period bookings may have additional cancellation or deposit conditions, which will be explained before confirmation.",
                "Any cancellation charges must be reasonable and consistent with applicable New Zealand law.",
            ],
        },
        {
            title: "Our Commitment to Your Cat",
            blocks: [
                "Mākara Village Boarding Cattery is a family-run business built around a genuine love of cats.",
                "We aim to provide a welcoming, caring and enjoyable environment where cats can settle in, relax, explore and receive individual attention.",
                { closing: "Our goal is simple: A country holiday for your cat." },
            ],
        },
    ],
    privacy:
        "Placeholder — the Privacy Policy for Mākara Village Boarding Cattery will be published here once supplied and confirmed by the owner. Any details you send through this website are used only to respond to your booking request.",
};

// ---- PHOTOGRAPHY ----------------------------------------------
// Genuine cattery/property photos ONLY for gallery/facility slots.
// Files live in /app/frontend/public/photos/ and are listed here.
// orientation: "portrait" | "landscape" | "square" lets the layouts
// treat each photo intentionally instead of forcing one crop.
// NOTE: heroBg / propertyWide / care below are TEMPORARY warm
// stand-in atmosphere images (a sunny cat, Mākara-style hills) used
// at the owner's request until the authentic uploads arrive.
export const photos = {
    heroBg: {
        src: "/photos/cattery-two-cats-tree.webp",
        alt: "Two cats — a tabby in a purple collar on a green platform and a fluffy ragdoll with blue eyes — beside a natural climbing tree in the Mākara Cattery enclosure",
    }, // Authentic supplied cattery photograph
    propertyWide: {
        src: "/photos/makara-property.webp",
        alt: "The Mākara Village Boarding Cattery property, with the cattery, gardens and surrounding Mākara hills",
    }, // Authentic supplied property photograph
    care: {
        src: "/photos/cattery-cat-stretch.webp",
        alt: "A brown cat stretching with its tail raised on a green platform inside the Mākara Cattery enclosure",
    }, // Authentic supplied cattery photograph
    // Real accommodation / climbing / beds shots for The Cattery
    cattery: [], // [{ src, alt, orientation }]
    // Large feature photo in The Cattery (authentic, supplied)
    catteryFeature: {
        src: "/photos/cattery-cat-window.png",
        alt: "A cat relaxing in a sunny window spot at Mākara Cattery",
    },
    // Richer selection for the Gallery (authentic, supplied photos only).
    // To add a photo: place the file in /public/photos/ and add a line here.
    gallery: [
        { src: "/photos/cattery-cat-shelf.webp", alt: "A tabby cat with white paws relaxing on a green carpeted shelf in a sunny cattery run", orientation: "portrait" },
        { src: "/photos/cattery-cat-tree-bengal.webp", alt: "An orange Bengal cat relaxing on a cat tree inside the cattery", orientation: "landscape" },
        { src: "/photos/cattery-cat-climbing.webp", alt: "A grey cat stretching up a climbing post inside the cattery", orientation: "portrait" },
        { src: "/photos/cattery-cat-enclosure-grey.webp", alt: "A grey cat with amber eyes in the outdoor cattery enclosure, behind a purple platform with colourful paw prints", orientation: "portrait" },
        { src: "/photos/cattery-cat-teddy.webp", alt: "A chocolate-brown cat with green eyes relaxing on a large beige teddy bear at Mākara Cattery", orientation: "portrait" },
        { src: "/photos/cattery-cat-house.webp", alt: "A black-and-white cat with green eyes resting in its cosy cat house, wrapped in a yellow blanket", orientation: "landscape" },
    ],
};
